import React from 'react';

const FinalLock = ({ visibility }) =>
  <div className={`step-hidden-visibility ${visibility ? 'step-visibility' : ''}`}>
    <div className="final-lock-wrapper">
      <svg height="505px" width="306px" version="1.1" viewBox="0 0 306 505">
        <defs>
          <rect height="36" id="path-2" width="207" rx="2.7" x="0" y="0" />
          <rect height="36" id="path-4" width="207" rx="2.7" x="0" y="0" />
        </defs>
        <g id="Page-1" fill="none" stroke="none" strokeWidth="1">
          <g id="Group-48" transform="translate(18.000000, 16.000000)">
            <g id="Group" transform="translate(0.000000, 80.800000)">
              <rect height="320" id="Rectangle-19" width="270" fill="#FFFFFF" x="0" y="0" />
              <rect height="1" id="Mask" width="270" fill="#5C666F" opacity="0.2" x="0" y="74" />
              <text
                id="Log-In"
                fill="#000000"
                fillOpacity="0.86"
                fontFamily="FaktPro-Medium, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="11.7"
              >
                <tspan x="52.2" y="62.6">ログイン</tspan>
              </text>
              <text
                id="Sign-Up"
                fill="#5C666F"
                fontFamily="FaktPro-Medium, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="11.7"
                opacity="0.6"
              >
                <tspan x="165.7" y="62.6">サインアップ</tspan>
              </text>
              <path
                id="Line"
                d="M135,74.45 L-3.19744231e-15,74.45"
                stroke="#5C666F"
                strokeLinecap="square"
                strokeWidth="0.9"
              />
              <g id="Username" transform="translate(31.050000, 176.800000)">
                <mask id="mask-3" fill="white">
                  <rect height="36" width="207" rx="2.7" x="0" y="0" />
                </mask>
                <g id="Mask">
                  <rect height="36" width="207" rx="2.7" x="0" y="0" />
                  <rect
                    height="36.9"
                    width="207.9"
                    rx="2.7"
                    stroke="#EEEEEE"
                    strokeWidth="0.9"
                    x="-0.45"
                    y="-0.45"
                  />
                </g>
                <text
                  id="Email"
                  fill="#000000"
                  fillOpacity="0.86"
                  fontFamily="FaktPro-Normal, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                  fontSize="12.6"
                  opacity="0.7"
                >
                  <tspan x="49.5" y="22.05">Email</tspan>
                </text>
                <g id="Rectangle-112-+-Shape">
                  <rect height="36" id="Rectangle-112" width="36" fill="#F1F1F1" x="0" y="0" />
                  <path
                    id="Shape"
                    d="M20.045157,24.4285714 L15.9544339,24.4285714 C14.5987682,24.4285714 13.5,23.3489395 13.5,22.0181836 L13.5,20.4109905 C13.5,19.3486359 14.2031953,18.4574473 15.1739239,18.1360087 C14.6470388,17.4408977 14.3181446,16.5613613 14.3181446,15.5890095 C14.3181446,13.3702794 15.966297,11.5714286 17.9997955,11.5714286 C20.0328849,11.5714286 21.6814463,13.3702794 21.6814463,15.5890095 C21.6814463,16.5613613 21.3521431,17.4404959 20.825667,18.1360087 C21.7963956,18.4574473 22.5,19.3490377 22.5,20.4109905 L22.5,22.0181836 C22.4995909,23.3493413 21.4004136,24.4285714 20.045157,24.4285714 L20.045157,24.4285714 Z M20.8633017,15.5890095 C20.8633017,13.8138647 19.581269,12.3746233 17.9997955,12.3746233 C16.4179128,12.3746233 15.1362893,13.8138647 15.1362893,15.5890095 C15.1362893,17.3641542 16.4183219,18.8037974 17.9997955,18.8037974 C19.58086,18.8037974 20.8633017,17.3641542 20.8633017,15.5890095 L20.8633017,15.5890095 Z M21.6814463,20.4109905 C21.6814463,19.5664106 21.0167038,18.8817463 20.1744239,18.8162532 C19.5636789,19.3076525 18.8167129,19.6069922 18.0002045,19.6069922 C17.1832871,19.6069922 16.435912,19.3076525 15.8255761,18.8162532 C14.9832962,18.8817463 14.3185537,19.5664106 14.3185537,20.4109905 L14.3185537,22.0181836 C14.3185537,22.9049524 15.0512022,23.6249749 15.954843,23.6249749 L20.0455661,23.6249749 C20.9492069,23.6249749 21.6818554,22.9049524 21.6818554,22.0181836 L21.6818554,20.4109905 L21.6814463,20.4109905 Z"
                    fill="#888888"
                  />
                </g>
              </g>
              <g id="google" transform="translate(31.050000, 100.800000)">
                <rect height="36" id="Rectangle-2" width="207" fill="#4285F4" rx="3" x="0" y="0" />
                <text
                  id="Login-with-Google"
                  fontFamily="FaktPro-Medium, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                  fontSize="12"
                  fontWeight="normal"
                  fill="#FFFFFF"
                >
                  <tspan x="50" y="21">Googleにログインする</tspan>
                </text>
                <g id="Rectangle-112-+-Shape">
                  <rect
                    height="36"
                    id="Rectangle-112"
                    width="36"
                    fill="#000000"
                    opacity="0.100000001"
                    x="0"
                    y="0"
                  />
                  <path
                    id="Shape"
                    d="M18.32782,20.1042393 L18.32782,17.7817944 L25.8879452,17.7817944 C25.9618537,18.1865563 26,18.66536 26,19.1836527 C26,20.9261034 25.5398599,23.0807201 24.0569215,24.6158537 C22.6145135,26.1707317 20.7715691,27 18.3302041,27 C13.8050961,27 10,23.1843786 10,18.5 C10,13.8156214 13.8050961,10 18.3302041,10 C20.8335568,10 22.6168976,11.0168409 23.9567874,12.3421893 L22.3737148,13.9809814 C21.4129042,13.0480546 20.1111608,12.3224448 18.32782,12.3224448 C15.0233944,12.3224448 12.4389808,15.0792683 12.4389808,18.5 C12.4389808,21.9207317 15.0233944,24.6775552 18.32782,24.6775552 C20.4711667,24.6775552 21.6918492,23.7865854 22.4738489,22.9770616 C23.1080316,22.3205575 23.525257,21.3826945 23.6897631,20.1017712 L18.32782,20.1042393 L18.32782,20.1042393 Z"
                    fill="#FFFFFF"
                  />
                </g>
              </g>
              <g id="Password" transform="translate(31.050000, 223.600000)">
                <mask id="mask-5" fill="white">
                  <rect height="36" width="207" rx="2.7" x="0" y="0" />
                </mask>
                <g id="Mask">
                  <rect height="36" width="207" rx="2.7" x="0" y="0" />
                  <rect
                    height="36.9"
                    width="207.9"
                    rx="2.7"
                    stroke="#EEEEEE"
                    strokeWidth="0.9"
                    x="-0.45"
                    y="-0.45"
                  />
                </g>
                <g id="Rectangle-112-+-Shape-Copy-2">
                  <rect height="36" id="Rectangle-112" width="36" fill="#F1F1F1" x="0" y="0" />
                  <path
                    id="Shape-Copy-2"
                    d="M21.7384615,24.75 L14.2615385,24.75 C13.3439538,24.75 12.6,23.9943983 12.6,23.0628692 L12.6,18.0002109 C12.6,17.0682599 13.3439538,16.3122363 14.2615385,16.3122363 L14.2615385,16.3122363 L14.2615385,15.0469937 C14.2615385,12.9502094 15.9351231,11.25 18,11.25 C20.0644615,11.25 21.7384615,12.9502094 21.7384615,15.0469937 L21.7384615,16.3122363 C22.6556308,16.3122363 23.4,17.0682599 23.4,18.0002109 L23.4,23.0628692 C23.4,23.9943983 22.6556308,24.75 21.7384615,24.75 L21.7384615,24.75 Z M20.9076923,15.0469937 C20.9076923,13.4163958 19.6058769,12.0937764 18,12.0937764 C16.3941231,12.0937764 15.0923077,13.4163958 15.0923077,15.0469937 L15.0923077,16.3122363 L20.9076923,16.3122363 L20.9076923,15.0469937 L20.9076923,15.0469937 Z M22.5692308,18.0002109 C22.5692308,17.5340245 22.1970462,17.1560127 21.7384615,17.1560127 L14.2615385,17.1560127 C13.8025385,17.1560127 13.4307692,17.5340245 13.4307692,18.0002109 L13.4307692,23.0628692 C13.4307692,23.5282118 13.8029538,23.9058017 14.2615385,23.9058017 L21.7384615,23.9058017 C22.1970462,23.9058017 22.5692308,23.5277899 22.5692308,23.0628692 L22.5692308,18.0002109 L22.5692308,18.0002109 Z M18,22.218249 C17.7707077,22.218249 17.5846154,22.029665 17.5846154,21.7967827 L17.5846154,19.2654536 C17.5846154,19.0325713 17.7702923,18.8435654 18,18.8435654 C18.2297077,18.8435654 18.4153846,19.0325713 18.4153846,19.2654536 L18.4153846,21.7967827 C18.4153846,22.029665 18.2292923,22.218249 18,22.218249 L18,22.218249 Z"
                    fill="#888888"
                  />
                </g>
                <text
                  fill="#000000"
                  fillOpacity="0.86"
                  fontFamily="FaktPro-Normal, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                  fontSize="12.6"
                  opacity="0.7"
                >
                  <tspan x="49.5" y="22.25">パスワード</tspan>
                </text>
              </g>
              <text
                id="Don’t-remember-your-"
                fill="#000000"
                fillOpacity="0.86"
                fontFamily="FaktPro-Normal, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="10.8"
              >
                <tspan x="60" y="291.5">パスワードを忘れた方はこちら</tspan>
              </text>
              <text
                id="OR"
                fill="#000000"
                fillOpacity="0.86"
                fontFamily="FaktPro-Normal, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="10.8"
              >
                <tspan x="120" y="163.5">または</tspan>
              </text>
            </g>
            <g id="Header">
              <path
                id="Rectangle-3"
                d="M3,0 L267,0 L267,4.4408921e-16 C268.656854,1.39730022e-16 270,1.34314575 270,3 L270,116 L0,116 L0,3 L4.4408921e-16,3 C2.41183085e-16,1.34314575 1.34314575,7.48448398e-16 3,4.4408921e-16 Z"
                fill="#E3E5E7"
              />
              <path
                id="path107"
                d="M150.723587,72.1315951 C149.648573,72.1315951 149.195754,71.9528613 148.756761,71.4552102 C148.58393,71.262458 148.514797,71.0662013 148.452577,70.6736877 L142.987637,49.6601952 C141.705226,42.2900527 132.776737,34.9304239 121.138247,34.9304239 L104.957738,34.9304239 L107.764526,45.7280507 L118.158628,45.7280507 C119.219815,45.7280507 120.049407,46.1275734 120.744191,46.9126005 C120.999982,47.2174994 121.331819,47.694123 121.376755,48.1847649 L125.690635,66.5452864 C126.962677,73.9189336 134.646777,82.0635894 146.281811,82.0635894 L162.852919,82.0635894 L160.734002,72.1315951 L150.723587,72.1315951 Z M154.456752,59.3258411 L156.306052,66.1247362 L173.139865,66.1247362 C175.217303,75.9831342 173.582314,85.1160831 167.681838,91.0984099 C155.739164,103.206752 130.754606,99.0923686 112.140626,81.036746 C109.233596,78.2330779 106.779385,75.2016117 104.542942,72.1035585 L114.677796,72.1035585 L112.320371,65.290645 L100.211778,65.290645 C99.0538056,63.1423343 97.9684222,61.0115465 97.1388298,58.8492175 L111.497692,58.8492175 L109.19903,52.036304 L95.0890452,52.036304 C92.676314,41.6276861 94.2145166,31.9199853 100.284368,25.75542 C112.078407,13.8012801 136.986919,18.0032777 155.590529,36.0553957 C158.846679,39.195504 161.535941,42.5844378 163.965956,46.0644909 L150.944811,46.0644909 L152.92892,52.8633861 L168.151941,52.8633861 C169.268434,55.0257151 170.295054,57.163512 171.096994,59.3258411 L154.456752,59.3258411 L154.456752,59.3258411 Z"
                fill="#009E4D"
                transform="translate(134.000000, 58.500000) scale(-1, 1) translate(-134.000000, -58.500000) "
              />
              <g id="Close" transform="translate(243.000000, 9.000000)">
                <circle id="Oval-257" cx="9" cy="9" fill="#FFFFFF" r="9" />
                <polygon
                  id="Shape-Copy"
                  fill="#000000"
                  points="13.05 5.76 12.24 4.95 9 8.19 5.76 4.95 4.95 5.76 8.19 9 4.95 12.24 5.76 13.05 9 9.81 12.24 13.05 13.05 12.24 9.81 9"
                />
              </g>
            </g>
            <g id="Login" transform="translate(0.000000, 400.600000)">
              <path
                id="Rectangle-50"
                d="M0,0 L270,0 L270,65.3948545 C270,67.0545505 268.659011,68.4 266.990905,68.4 L3.00909453,68.4 C1.34721751,68.4 0,67.0643536 0,65.3948545 L0,0 Z"
                fill="#009B4B"
              />
              <circle id="Oval-302" cx="135" cy="34.2" r="18" stroke="#FFFFFF" strokeWidth="3" />
              <polygon
                id="Shape"
                fill="#FFFFFF"
                points="133.2 30.06 134.46 28.8 139.86 34.2 134.46 39.6 133.2 38.34 137.34 34.2"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>;

export default FinalLock;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/OnboardingFlow/components/FinalLock.js